export type Role = 'viewer' | 'contributor' | 'editor' | 'admin'

export const ROLES: Role[] = ['viewer', 'contributor', 'editor', 'admin']

const RANK: Record<Role, number> = { viewer: 0, contributor: 1, editor: 2, admin: 3 }

function rank(role: string | null | undefined): number {
  return role != null && role in RANK ? RANK[role as Role] : 0
}

/** Add content (and comment on tasks); viewers are read-only. */
export function canEdit(role: string | null | undefined): boolean {
  return rank(role) >= RANK.contributor
}

/** Editor or above: may change anyone's rows. */
export function canModifyAny(role: string | null | undefined): boolean {
  return rank(role) >= RANK.editor
}

/** May this user edit or delete a row that was created by `createdBy`?
 *  Editors and admins: any row. Contributors: only their own. */
export function canModifyRow(
  role: string | null | undefined,
  createdBy: string | null | undefined,
  email: string | null | undefined,
): boolean {
  return canModifyAny(role) || (!!createdBy && createdBy === email)
}
